var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 5h-.834v6.667A.836.836 0 0 1 15 12.5H5v.833C5 14.25 5.75 15 6.667 15H15l3.333 3.333V6.667c0-.917-.75-1.667-1.666-1.667zm-2.5 4.167V3.333c0-.916-.75-1.666-1.667-1.666H3.333c-.916 0-1.666.75-1.666 1.666v10.834L5 10.833h7.5c.917 0 1.667-.75 1.667-1.666z",
    fill: "#c650ee"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.dbe7386939edc20deb481e9d19c615c5.svg";
export { ForwardRef as ReactComponent };